module.exports = __webpack_public_path__ + "static/media/process.e68e907e.svg";